import React from 'react';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import './CustomGHITooltip.css';

export function CustomGHITooltip({ active, payload, label }) {
  const { t } = useTranslation();
  if (!active || !payload || payload.length === 0) return null;
  
  const campo = payload[0]?.value || 0;
  const retro = payload[1]?.value || 0;
  const gap = campo - retro;
  const shadeFactor = campo > 0 ? ((gap / campo) * 100).toFixed(1) : 0;
  
  return (
    <div className="custom-ghi-tooltip">
      <p className="custom-ghi-tooltip__time">
        {format(parseISO(label), 'MMM dd, HH:mm')}
      </p>
      
      <div className="custom-ghi-tooltip__row">
        <span className="custom-ghi-tooltip__label" style={{ color: '#4A7A8A' }}>
          {t('analytics.radiation.ghiWithLocation', { location: t('analytics.labels.field') })}:
        </span>
        <span className="custom-ghi-tooltip__value">{Math.round(campo)} W/m²</span>
      </div>
      
      <div className="custom-ghi-tooltip__row">
        <span className="custom-ghi-tooltip__label" style={{ color: '#5A7A3A' }}>
          {t('analytics.radiation.ghiWithLocation', { location: t('analytics.labels.underPanel') })}:
        </span>
        <span className="custom-ghi-tooltip__value">{Math.round(retro)} W/m²</span>
      </div>
      
      <div className="custom-ghi-tooltip__row custom-ghi-tooltip__row--highlight">
        <span className="custom-ghi-tooltip__label" style={{ color: '#7C3AED' }}>
          {t('analytics.radiation.gap')} (Δ):
        </span>
        <span className="custom-ghi-tooltip__value">{Math.round(gap)} W/m²</span>
      </div>
      
      <div className="custom-ghi-tooltip__row">
        <span className="custom-ghi-tooltip__label">{t('analytics.radiation.shadeFactor')}:</span>
        <span className="custom-ghi-tooltip__value">{shadeFactor}%</span>
      </div>
    </div>
  );
}

CustomGHITooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string,
};
